export default __webpack_public_path__ + "static/media/240.523f51bc.png";